import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchfood(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .post('/admin/get/food', {})
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  
  
    addfood(ctx, requestBody) {
      return new Promise((resolve, reject) => {
        axios
          .post('admin/add/food', requestBody)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    
  
    updatefood(ctx, requestBody) {
      return new Promise((resolve, reject) => {
        axios
          .post('admin/update/food', requestBody)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deletefood(ctx, requestBody) {
      return new Promise((resolve, reject) => {
        axios
          .post('admin/delete/food', requestBody)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },



    addUser(ctx, requestBody) {
      return new Promise((resolve, reject) => {
        axios
          .post('admins/registerAssociate', requestBody)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
